import { createContext, useContext, useState, useCallback } from "react";

const UIContext = createContext(null);

export function UIProvider({ children }) {
  const [dataVersion, setDataVersion] = useState(0);
  const [quickAction, setQuickAction] = useState(null); // {prefill, onSuccess} | null
  const [completeAction, setCompleteAction] = useState(null); // {action, onSuccess} | null
  const [entityModal, setEntityModal] = useState(null); // {type, prefill, record, onSuccess} | null
  const [taskModal, setTaskModal] = useState(null); // {record, prefill, onSuccess} | null

  const bump = useCallback(() => setDataVersion((v) => v + 1), []);

  const openQuickAction = useCallback((prefill = {}, onSuccess) => setQuickAction({ prefill, onSuccess }), []);
  const openTask = useCallback((recordOrOpts, onSuccess) => {
    if (recordOrOpts && (recordOrOpts.prefill || recordOrOpts.record)) setTaskModal({ onSuccess, ...recordOrOpts });
    else setTaskModal({ record: recordOrOpts, onSuccess });
  }, []);
  const openCompleteAction = useCallback((action, onSuccess) => setCompleteAction({ action, onSuccess }), []);
  const openEntity = useCallback(
    (type, opts = {}) => setEntityModal({ type, ...opts }),
    []
  );

  const closeAll = useCallback(() => {
    setQuickAction(null);
    setCompleteAction(null);
    setEntityModal(null);
    setTaskModal(null);
  }, []);

  return (
    <UIContext.Provider
      value={{
        dataVersion,
        bump,
        quickAction,
        completeAction,
        entityModal,
        taskModal,
        openQuickAction,
        openTask,
        openCompleteAction,
        openEntity,
        closeAll,
        setQuickAction,
        setCompleteAction,
        setEntityModal,
        setTaskModal,
      }}
    >
      {children}
    </UIContext.Provider>
  );
}

export const useUI = () => useContext(UIContext);
